import React, { useEffect, useState } from 'react'
import {  useBnsYiXiangKeHuUpdateQuery } from '../../store/ReactWebSiteApi';
import { Descriptions, Space, Spin } from 'antd';
import DocTitle from '../../cpn/DocTitle';
function ClientDesc(props) {
    const [info,setInfo] = useState({
        ebn_team_num:'',
    })
    const {data,isSuccess} = useBnsYiXiangKeHuUpdateQuery({byxkh_id:props.byxkh_id},{skip:!props.byxkh_id})
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){
                console.log(data);                        
                setInfo({
                    byxkh_dept_id:data.Result.byxkh_dept_id,        
                    byxkh_dept_name:data.Result.byxkh_dept_name,        
                    byxkh_bg_name:data.Result.byxkh_bg_name,        
                    byxkh_meijie_name:data.Result.byxkh_meijie_name,  
                    byxkh_ctime:data.Result.byxkh_ctime,                                       
                    byxkh_cname:data.Result.byxkh_cname,                                       
                    byxkh_riqi:data.Result.byxkh_riqi,                                                
                    byxkh_name:data.Result.byxkh_name,                                                
                    byxkh_content:data.Result.byxkh_content,                                                
                })
                // console.log(array);
                
            }
        }
    },[data, isSuccess])

    const items = [
        {
            key:'4',
            label:'客户名称',
            children:info.byxkh_name,
            contentStyle:{fontSize:"18px"},
            span:3
        },
        {
            key:'2',
            label:'媒介',
            children:info.byxkh_meijie_name,
            contentStyle:{fontSize:"18px"},
        },
      
        {
            key:'3',
            label:'获取日期',
            children:info.byxkh_riqi,
            contentStyle:{fontSize:"18px"},
        },
        {
            key:'5',
            label:'产品',
            children: info.byxkh_bg_name,
            contentStyle:{fontSize:"18px"},
        }, 
        {
            key:'byxkh_content',
            label:'备注',
            children:<div  dangerouslySetInnerHTML={{__html:info.byxkh_content}}></div>,
            contentStyle:{fontSize:"18px"},
            span:3
        },
       
        {
            key:'7',
            label:'部门',
            children:<>{info.byxkh_dept_name}</>,
            labelStyle:{width:'120px'},
            contentStyle:{fontSize:"18px"}
        },
        {
            key:'8',
            label:'新增时间',
            children:info.byxkh_cname+info.byxkh_ctime,
            contentStyle:{fontSize:"18px"},
        },
        {
            key:'9',
            label:'操作',
            children:   <Space>
                            
                        </Space>,
        },
    ]
    return (
        <>
            {info.byxkh_ctime ? <div 
                                    style={{border:'2px solid #eee',margin:"10px",padding:'20px'}}
                                >
                                   <DocTitle
                                        name='意向客户登记表'
                                        num={props.byxkh_id}                        
                                    />                                    
                                    <Descriptions
                                        items={items}
                                        bordered
                                    />
                                </div>:  <Spin  size='large' />}
        </> 
    )
}

export default ClientDesc